import { gql } from '@apollo/client'

const DICTIONARY_WORD_FRAGMENT = gql`
  fragment DictionaryWordFragment on DictionaryWord {
    id
    term
    type
    source
    languageId
    updatedBy {
      id
      name
    }
    updatedAt
  }
`

export default DICTIONARY_WORD_FRAGMENT
